<template>
  <m-linear-progress
    v-if="open"
    :indeterminate="indeterminate"
    :open="open"
    v-bind="$attrs"
    v-on="$listeners" />
</template>

<script>
import Vue from 'vue'
import LinearProgress from 'material-components-vue/dist/linear-progress'

Vue.use(LinearProgress)

export default {
  props: {
    indeterminate: {
      default: true,
      type: Boolean
    },
    open: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="scss">
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/linear-progress/styles";
  @import "@material/floating-label/_mixins.scss";

  .mdc-linear-progress {
    @include mdc-linear-progress-bar-color($mdc-theme-primary)
  }
</style>
